export default {
  position: 'bottom',
  time: 2000,
  closeIcon: 'close',
  close: true,
  successIcon: 'check_circle',
  infoIcon: 'info',
  warningIcon: 'priority_high',
  errorIcon: 'warning'
};



// WEBPACK FOOTER //
// ./src/muse-ui-plugin/muse-ui-toast/config.js